import cx from 'classnames';
import { SpinnerSize } from '../../../../ui-toolkit';
import React from 'react';
import * as yup from 'yup';
import { Form, Formik } from 'formik';
import { ButtonTW } from '../../../../tailwindComponents/buttonTW/ButtonTW';
import { SpinnerTW } from '../../../../tailwindComponents/spinnerTW/SpinnerTW';
import { Show } from '../../../shared/Show';
import { ISigningAppointmentEditFormData } from '../../../../types/signingAppointment/ISigningAppointmentEditFormData';
import { buildRequest, NewSignerFormValues } from './NewSignerFormValues';
import { TextFieldTW } from '../../../../tailwindComponents/textInputTW/TextFieldTW';
import { PhoneNumberFieldTW } from '../../../../tailwindComponents/phoneNumberFieldTW/PhoneNumberFieldTW';
import { useSelectAppointmentFromPathParam } from '../../../../utilities/order/scheduling/useSomeAppointmentFromParam';

export interface CreateNewSignerFormProps {
  onCreate: () => void;
  onSaveEditions: (formData: ISigningAppointmentEditFormData) => Promise<void>;
}

export const CreateNewSignerForm = ({ onCreate, onSaveEditions }: CreateNewSignerFormProps) => {
  const { appointmentFromPath } = useSelectAppointmentFromPathParam();
  if (!appointmentFromPath) {
    return null;
  }
  const initialValues: NewSignerFormValues = { id: appointmentFromPath.id, signer: {} };

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={async (values: NewSignerFormValues) => {
          const request = buildRequest(values);
          await onSaveEditions(request);
          onCreate();
        }}
        validationSchema={ValidationSchema}
      >
        {({ isValid, isSubmitting }) => (
          <Form>
            <section className={cx('grid gap-4', 'grid-cols-3')} data-test-id="new-user-form">
              <TextFieldTW labelText="First Name" name={'signer.firstName'} placeholder="Beth" isRequired />
              <TextFieldTW labelText="Middle Name" name={`signer.middleName`} placeholder="B" />
              <TextFieldTW labelText="Last Name" name={'signer.lastName'} placeholder="Buyer" isRequired />
              <TextFieldTW labelText="Email Address" name={'signer.email'} placeholder="johnnylappleseed@gmail.com" />
              <PhoneNumberFieldTW labelText="Phone Number" name={'signer.phoneNumber'} />
            </section>
            <div className={'mt-4 flex justify-end'}>
              <ButtonTW type={'submit'} disabled={!isValid}>
                <Show when={isSubmitting} fallback={'Create'}>
                  <SpinnerTW className={'border-white'} size={SpinnerSize.small} />
                </Show>
              </ButtonTW>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

const ValidationSchema = yup.object().shape({
  signer: yup.object().shape({
    firstName: yup.string().required(),
    middleName: yup.string().nullable().notRequired(),
    lastName: yup.string().required(),
    email: yup.string().email().nullable().notRequired(),
    phoneNumber: yup.string().nullable().notRequired(),
  }),
});
